function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.7589 128C21.4678 128 13.9092 120.412 13.9092 111.086C13.9092 101.76 21.468 94.1724 30.7589 94.1724C40.0497 94.1724 47.6083 101.76 47.6083 111.086C47.6083 120.412 40.0497 128 30.7589 128ZM30.7589 99.4623C24.3739 99.4623 19.1791 104.677 19.1791 111.086C19.1791 117.495 24.3739 122.71 30.7589 122.71C37.1438 122.71 42.3384 117.495 42.3384 111.086C42.3384 104.677 37.1441 99.4623 30.7589 99.4623Z",
  fill: "#6F62FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.7587 125.355C38.6092 125.355 44.9734 118.967 44.9734 111.086C44.9734 103.206 38.6092 96.8174 30.7587 96.8174C22.9081 96.8174 16.5439 103.206 16.5439 111.086C16.5439 118.967 22.9081 125.355 30.7587 125.355Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.7588 84.6246C21.4678 84.6246 13.9092 77.037 13.9092 67.7109C13.9092 58.3847 21.468 50.7974 30.7588 50.7974C40.0497 50.7974 47.6083 58.385 47.6083 67.7109C47.6085 77.0373 40.0497 84.6246 30.7588 84.6246ZM30.7588 56.0873C24.3739 56.0873 19.1791 61.3016 19.1791 67.7109C19.1791 74.1202 24.3739 79.3347 30.7588 79.3347C37.1438 79.3347 42.3384 74.1202 42.3384 67.7109C42.3384 61.3016 37.1441 56.0873 30.7588 56.0873Z",
  fill: "#6F62FF"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.7587 81.9797C38.6092 81.9797 44.9734 75.5914 44.9734 67.7109C44.9734 59.8305 38.6092 53.4421 30.7587 53.4421C22.9081 53.4421 16.5439 59.8305 16.5439 67.7109C16.5439 75.5914 22.9081 81.9797 30.7587 81.9797Z",
  fill: "white"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.7587 38.6047C38.6092 38.6047 44.9734 32.2164 44.9734 24.3359C44.9734 16.4555 38.6092 10.0671 30.7587 10.0671C22.9081 10.0671 16.5439 16.4555 16.5439 24.3359C16.5439 32.2164 22.9081 38.6047 30.7587 38.6047Z",
  fill: "#D9DCE1"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.7589 41.2494C21.4678 41.2494 13.9092 33.6618 13.9092 24.3359C13.9092 15.01 21.468 7.42236 30.7589 7.42236C40.0497 7.42236 47.6083 15.01 47.6083 24.3359C47.6083 33.6618 40.0497 41.2494 30.7589 41.2494ZM30.7589 12.7123C24.3739 12.7123 19.1791 17.9266 19.1791 24.3359C19.1791 30.7452 24.3739 35.9594 30.7589 35.9594C37.1438 35.9594 42.3384 30.7452 42.3384 24.3359C42.3384 17.9266 37.1441 12.7123 30.7589 12.7123Z",
  fill: "#6F62FF"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.8107 64.889C26.1177 64.889 25.4379 64.606 24.9478 64.1138C24.4577 63.6221 24.1758 62.9397 24.1758 62.2441C24.1758 61.5484 24.4575 60.866 24.9478 60.3714C25.4379 59.8795 26.1177 59.5962 26.8107 59.5962C27.5037 59.5962 28.1835 59.8792 28.6734 60.3714C29.1635 60.8631 29.4457 61.5455 29.4457 62.2441C29.4457 62.9397 29.1637 63.6221 28.6734 64.1138C28.1835 64.606 27.5063 64.889 26.8107 64.889Z",
  fill: "#444B54"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M34.3205 64.889C33.6275 64.889 32.9477 64.606 32.4576 64.1138C31.9675 63.6221 31.6855 62.9397 31.6855 62.2441C31.6855 61.5484 31.9672 60.866 32.4576 60.3714C32.9477 59.8795 33.6275 59.5962 34.3205 59.5962C35.0135 59.5962 35.6933 59.8792 36.1831 60.3714C36.6732 60.8631 36.9554 61.5455 36.9554 62.2441C36.9554 62.9397 36.6735 63.6221 36.1831 64.1138C35.6933 64.606 35.0161 64.889 34.3205 64.889Z",
  fill: "#444B54"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M31.056 75.8244C27.5897 75.8244 24.7695 72.9938 24.7695 69.5146C24.7695 68.054 25.9495 66.8696 27.4045 66.8696H34.7067C36.1617 66.8696 37.3416 68.054 37.3416 69.5146C37.3416 72.9938 34.522 75.8244 31.056 75.8244Z",
  fill: "#444B54"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.8976 22.0009C26.2046 22.0009 25.5248 21.7179 25.0347 21.2259C24.5446 20.7339 24.2627 20.0515 24.2627 19.3559C24.2627 18.6603 24.5444 17.9779 25.0347 17.4859C25.5248 16.9942 26.2046 16.7109 26.8976 16.7109C27.5933 16.7109 28.2704 16.9939 28.7603 17.4859C29.253 17.9779 29.5326 18.6603 29.5326 19.3559C29.5326 20.0515 29.253 20.7339 28.7603 21.2259C28.2704 21.7176 27.5906 22.0009 26.8976 22.0009Z",
  fill: "#444B54"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M34.4074 22.0009C33.7144 22.0009 33.0372 21.7179 32.5445 21.2259C32.0544 20.7339 31.7725 20.0515 31.7725 19.3559C31.7725 18.6603 32.0541 17.9779 32.5445 17.4859C33.0346 16.9942 33.7144 16.7109 34.4074 16.7109C35.103 16.7109 35.7828 16.9939 36.27 17.4859C36.7628 17.9779 37.0423 18.6603 37.0423 19.3559C37.0423 20.0515 36.7628 20.7339 36.27 21.2259C35.7802 21.7176 35.103 22.0009 34.4074 22.0009Z",
  fill: "#444B54"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M34.6188 29.3866C34.6188 27.2458 32.8906 25.5115 30.7581 25.5115C28.6264 25.5115 26.8984 27.246 26.8984 29.3866H34.6188Z",
  fill: "#D9DCE1"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M34.6193 32.0315H26.8986C25.4436 32.0315 24.2637 30.8471 24.2637 29.3866C24.2637 25.7913 27.1774 22.8665 30.7583 22.8665C34.3402 22.8665 37.2539 25.7915 37.2539 29.3866C37.2542 30.8474 36.0743 32.0315 34.6193 32.0315Z",
  fill: "#444B54"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.3996 111.245C25.7066 111.245 25.0297 110.962 24.537 110.47C24.0469 109.975 23.7646 109.295 23.7646 108.6C23.7646 107.902 24.0466 107.222 24.537 106.727C25.0297 106.235 25.7066 105.955 26.3996 105.955C27.0955 105.955 27.7724 106.235 28.2651 106.727C28.7552 107.219 29.0345 107.902 29.0345 108.6C29.0345 109.295 28.7552 109.975 28.2651 110.47C27.7724 110.962 27.0926 111.245 26.3996 111.245Z",
  fill: "#444B54"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.4923 111.245C34.7964 111.245 34.1195 110.962 33.6268 110.47C33.1367 109.975 32.8545 109.295 32.8545 108.6C32.8545 107.902 33.1364 107.219 33.6268 106.727C34.1166 106.235 34.7964 105.955 35.4923 105.955C36.1853 105.955 36.8622 106.235 37.355 106.727C37.8451 107.222 38.1273 107.902 38.1273 108.6C38.1273 109.295 37.8453 109.975 37.355 110.47C36.8622 110.962 36.1853 111.245 35.4923 111.245Z",
  fill: "#444B54"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.7587 38.6047C38.6093 38.6047 44.9734 32.2164 44.9734 24.3359C44.9734 16.4555 38.6093 10.0671 30.7587 10.0671C22.9081 10.0671 16.5439 16.4555 16.5439 24.3359C16.5439 32.2164 22.9081 38.6047 30.7587 38.6047Z",
  fill: "white"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M84.3738 34.6629H59.4299C57.9748 34.6629 56.7949 33.4784 56.7949 32.0179V15.343C56.7949 13.8824 57.9748 12.698 59.4299 12.698H84.3738C85.8288 12.698 87.0088 13.8824 87.0088 15.343V32.0179C87.0088 33.4784 85.8288 34.6629 84.3738 34.6629ZM62.0648 29.3729H81.7389V17.9879H62.0648V29.3729V29.3729Z",
  fill: "#6F62FF"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M118.364 58.718H59.4297V76.7038H118.364V58.718Z",
  fill: "#D9DCE1"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M118.365 79.3487H59.4299C57.9748 79.3487 56.7949 78.1643 56.7949 76.7037V58.718C56.7949 57.2574 57.9748 56.073 59.4299 56.073H118.365C119.82 56.073 121 57.2574 121 58.718V76.7037C121 78.1643 119.82 79.3487 118.365 79.3487ZM62.0648 74.0588H115.73V61.3629H62.0648V74.0588Z",
  fill: "#6F62FF"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M76.7325 122.724H59.4299C57.9748 122.724 56.7949 121.54 56.7949 120.079V102.093C56.7949 100.633 57.9748 99.4485 59.4299 99.4485H76.7325C78.1875 99.4485 79.3674 100.633 79.3674 102.093V120.079C79.3674 121.54 78.1875 122.724 76.7325 122.724ZM62.0648 117.434H74.0975V104.738H62.0648V117.434V117.434Z",
  fill: "#6F62FF"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.8107 64.889C26.1177 64.889 25.4379 64.606 24.9478 64.1138C24.4577 63.6221 24.1758 62.9397 24.1758 62.2441C24.1758 61.5484 24.4575 60.866 24.9478 60.3714C25.4379 59.8795 26.1177 59.5962 26.8107 59.5962C27.5037 59.5962 28.1835 59.8792 28.6734 60.3714C29.1635 60.8631 29.4457 61.5455 29.4457 62.2441C29.4457 62.9397 29.1637 63.6221 28.6734 64.1138C28.1835 64.606 27.5063 64.889 26.8107 64.889Z",
  fill: "#6F62FF"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M34.3205 64.889C33.6275 64.889 32.9477 64.606 32.4576 64.1138C31.9675 63.6221 31.6855 62.9397 31.6855 62.2441C31.6855 61.5484 31.9672 60.866 32.4576 60.3714C32.9477 59.8795 33.6275 59.5962 34.3205 59.5962C35.0135 59.5962 35.6933 59.8792 36.1831 60.3714C36.6732 60.8631 36.9554 61.5455 36.9554 62.2441C36.9554 62.9397 36.6735 63.6221 36.1831 64.1138C35.6933 64.606 35.0161 64.889 34.3205 64.889Z",
  fill: "#6F62FF"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M31.056 75.8244C27.5897 75.8244 24.7695 72.9938 24.7695 69.5146C24.7695 68.054 25.9495 66.8696 27.4045 66.8696H34.7067C36.1617 66.8696 37.3416 68.054 37.3416 69.5146C37.3416 72.9938 34.522 75.8244 31.056 75.8244Z",
  fill: "#6F62FF"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.8976 22.0009C26.2046 22.0009 25.5248 21.7179 25.0347 21.2259C24.5446 20.7339 24.2627 20.0515 24.2627 19.3559C24.2627 18.6603 24.5444 17.9779 25.0347 17.4859C25.5248 16.9942 26.2046 16.7109 26.8976 16.7109C27.5933 16.7109 28.2704 16.9939 28.7603 17.4859C29.253 17.9779 29.5326 18.6603 29.5326 19.3559C29.5326 20.0515 29.253 20.7339 28.7603 21.2259C28.2704 21.7176 27.5906 22.0009 26.8976 22.0009Z",
  fill: "#6F62FF"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M34.4074 22.0009C33.7144 22.0009 33.0372 21.7179 32.5445 21.2259C32.0544 20.7339 31.7725 20.0515 31.7725 19.3559C31.7725 18.6603 32.0541 17.9779 32.5445 17.4859C33.0346 16.9942 33.7144 16.7109 34.4074 16.7109C35.103 16.7109 35.7828 16.9939 36.27 17.4859C36.7628 17.9779 37.0423 18.6603 37.0423 19.3559C37.0423 20.0515 36.7628 20.7339 36.27 21.2259C35.7802 21.7176 35.103 22.0009 34.4074 22.0009Z",
  fill: "#6F62FF"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M34.6188 29.3866C34.6188 27.2458 32.8906 25.5115 30.7581 25.5115C28.6264 25.5115 26.8984 27.246 26.8984 29.3866H34.6188Z",
  fill: "#D9DCE1"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M34.6193 32.0315H26.8986C25.4436 32.0315 24.2637 30.8471 24.2637 29.3866C24.2637 25.7913 27.1774 22.8665 30.7583 22.8665C34.3402 22.8665 37.2539 25.7915 37.2539 29.3866C37.2542 30.8474 36.0743 32.0315 34.6193 32.0315Z",
  fill: "#6F62FF"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M84.3746 15.343H59.4307V32.0179H84.3746V15.343Z",
  fill: "white"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M118.365 58.718H59.4307V76.7038H118.365V58.718Z",
  fill: "white"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M76.7333 102.093H59.4307V120.079H76.7333V102.093Z",
  fill: "white"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.3996 111.245C25.7066 111.245 25.0297 110.962 24.537 110.47C24.0469 109.975 23.7646 109.295 23.7646 108.6C23.7646 107.901 24.0466 107.222 24.537 106.727C25.0297 106.235 25.7066 105.955 26.3996 105.955C27.0955 105.955 27.7724 106.235 28.2651 106.727C28.7552 107.219 29.0345 107.901 29.0345 108.6C29.0345 109.295 28.7552 109.975 28.2651 110.47C27.7724 110.962 27.0926 111.245 26.3996 111.245Z",
  fill: "#6F62FF"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.4933 111.245C34.7974 111.245 34.1205 110.962 33.6278 110.47C33.1377 109.975 32.8555 109.295 32.8555 108.6C32.8555 107.901 33.1374 107.219 33.6278 106.727C34.1176 106.235 34.7974 105.955 35.4933 105.955C36.1863 105.955 36.8632 106.235 37.3559 106.727C37.846 107.222 38.1283 107.901 38.1283 108.6C38.1283 109.295 37.8463 109.975 37.3559 110.47C36.8632 110.962 36.1863 111.245 35.4933 111.245Z",
  fill: "#6F62FF"
});

var _ref34 =
/*#__PURE__*/
React.createElement("rect", {
  x: 23.9199,
  y: 113.827,
  width: 14.1744,
  height: 4.44636,
  rx: 2.22318,
  fill: "#6F62FF"
});

var SvgInsight = function SvgInsight(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 121,
    height: 128,
    viewBox: "0 0 121 128",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInsight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/insight.8cdcee92.svg";
export { ForwardRef as ReactComponent };